import { Box, CircularProgress } from '@mui/material';
import { useSavedFilters } from '../../sic-lib/api/hooks/useSavedFilters';
import { useAppSelector } from '../../store/hooks';
import NewRecentInboxFiltering from './NewRecentFilters/NewRecentInboxFiltering';
import NewRecentList from './NewRecentList/NewRecentList';

export default function NewRecent() {
    const currentFilter = useAppSelector(state => state.inbox.filters);
    const { data: savedFilters, isLoading: isLoadingFilters } = useSavedFilters();

    if (isLoadingFilters) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                    height: '100%',
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <div className="newRecent">
                <div className="newRecent__actions">
                    <NewRecentInboxFiltering
                        currentFilter={currentFilter}
                        savedFilters={savedFilters}
                    />
                </div>
                <div className="newRecent__list">
                    <NewRecentList currentFilterOptions={currentFilter.filter} />
                </div>
            </div>
        </>
    );
}
